export default "__VITE_ASSET__CtOZbbnz__"